import { leadApi } from '../config';

export async function sendLead(fields) {
  const res = await fetch(leadApi.url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Api-Key': leadApi.key,
    },
    body: JSON.stringify({
      ...fields,
      source: fields.source || leadApi.source,
      page: window.location.href,
      referrer: document.referrer,
    }),
  });

  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(body.error || 'Could not send your request. Please try again.');
  }
  return body;
}
